import React from 'react';

import { Layout  } from '../components';
import RepoDetail from '../components/repo-detail';


const Repo = () => {


  return (
    <Layout>
    
        <RepoDetail />
    
    </Layout>
  );
};

export default Repo;
